import { FC } from 'react';

import { IconProps } from './types';

export const FlagIcon: FC<IconProps> = ({
	color = 'currentColor',
	height = 22,
	size,
	width = 18,
	className,
}) => (
	<svg
		className={className}
		viewBox="0 0 18 22"
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M8.636 14.93C9.952 15.46 11.312 16 13 16c3.25 0 4.491-1.08 4.707-1.29A1 1 0 0 0 18 14V2c0-.39-.242-.73-.598-.9a1.025 1.025 0 0 0-1.084.17C16.31 1.28 15.444 2 13 2c-1.308 0-2.435-.45-3.628-.93h-.008C8.048.54 6.688 0 5 0 1.75 0 .509 1.08.293 1.29.105 1.48 0 1.74 0 2v19c0 .55.448 1 1 1s1-.45 1-1v-6.46c.439-.22 1.367-.54 3-.54 1.308 0 2.435.45 3.628.93h.008Zm.728-1.86C8.048 12.54 6.688 12 5 12c-1.301 0-2.28.17-3 .39V2.54C2.439 2.32 3.367 2 5 2c1.308 0 2.435.45 3.628.93h.008C9.952 3.46 11.312 4 13 4c1.301 0 2.279-.17 3-.39v9.85c-.438.22-1.367.54-3 .54-1.308 0-2.435-.45-3.628-.93h-.008Z"
		/>
	</svg>
);
